import { useCallback, useEffect, useState } from 'react';
import { CheckSquare, ChevronRight } from 'lucide-react';

/**
 * Úkoly z Komunikace v Cockpitu — sražený proužek u spodní hrany, stejný
 * jazyk jako sražené kontroly a dávka v `PracovniPlocha` (`Prouzek`).
 *
 * Jen připomínka: kreslí se, když nějaký úkol řeším, a **na směnu ani její
 * ukončení nemá vliv** (úkoly Mojí směny jsou jiná věc). Klepnutí otevře
 * Komunikace → Úkoly. Počet se obnoví po návratu do aplikace a po odkliknutí.
 */
const FIALOVA = '#B47AEA';
const CERVENA = '#F87171';

export default function UkolyProuzek({ onNavigate, isDark, style }) {
    const [ukoly, setUkoly] = useState([]);

    const nacti = useCallback(() => {
        fetch('/api/ukoly/moje').then(r => (r.ok ? r.json() : null))
            .then(d => d && setUkoly(Array.isArray(d.ukoly) ? d.ukoly : [])).catch(() => {});
    }, []);

    useEffect(() => {
        nacti();
        window.addEventListener('app-resumed', nacti);
        window.addEventListener('ukoly-zmena', nacti);
        window.addEventListener('focus', nacti);
        return () => {
            window.removeEventListener('app-resumed', nacti);
            window.removeEventListener('ukoly-zmena', nacti);
            window.removeEventListener('focus', nacti);
        };
    }, [nacti]);

    if (!ukoly.length) return null;

    const ted = new Date();
    const konecDne = new Date(); konecDne.setHours(23, 59, 59, 999);
    const po = ukoly.filter(u => u.termin && new Date(u.termin) < ted).length;
    const dnes = ukoly.filter(u => u.termin && new Date(u.termin) >= ted && new Date(u.termin) <= konecDne).length;
    const doplnek = po ? `${po} po termínu` : dnes ? `${dnes} dnes` : String(ukoly.length);
    const label = ukoly.length === 1 ? ukoly[0].nazev : `Úkoly · ${ukoly.length}`;

    return (
        <button
            type="button"
            onClick={() => onNavigate?.('zpravy', { tab: 'ukoly' })}
            style={{
                flexShrink: 0,
                display: 'flex', alignItems: 'center', gap: 9,
                minHeight: 40,
                margin: '0 12px', width: 'calc(100% - 24px)',
                padding: '0 12px', borderRadius: 10,
                background: isDark ? 'rgba(255,255,255,0.045)' : 'var(--surface-elevated)',
                border: `1px solid ${po ? 'rgba(248,113,113,0.35)' : (isDark ? 'rgba(255,255,255,0.09)' : 'var(--border-default)')}`,
                cursor: 'pointer', font: 'inherit', textAlign: 'left',
                WebkitTapHighlightColor: 'transparent',
                ...style,
            }}>
            <CheckSquare size={14} style={{ color: po ? CERVENA : FIALOVA, flexShrink: 0 }} />
            <span style={{
                flex: 1, minWidth: 0,
                fontSize: 12.5, fontWeight: 600, color: 'var(--text-primary)',
                whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
            }}>{label}</span>
            <span style={{
                fontSize: 11.5, fontWeight: 700, color: po ? CERVENA : FIALOVA,
                fontVariantNumeric: 'tabular-nums', flexShrink: 0,
            }}>{doplnek}</span>
            <ChevronRight size={14} style={{ color: 'var(--text-muted)', flexShrink: 0 }} />
        </button>
    );
}
